import { Row } from "antd";
import { useSelector } from "react-redux";

type CommentTooltipProps = {
  name: string;
};

export const CommentTooltip = ({ name }: CommentTooltipProps) => {
  const metaData = useSelector((state: any) => state.metaData);

  return (
    <Row>
      <p className="mt-0 text-md w-500 mb-3">Email template will be used:</p>
      <p className="mt-0 text-md mb-3">Subject: Request Completed</p>
      <p className="mt-0 text-md mb-3">
        Dear [User’s First Name + Last Name] Your request titled “{name}” has
        been completed.
      </p>
      <p className="my-0 text-md">Comment:</p>
      <p className="mt-0 text-md w-500 mb-3">
        [Comment specified on closing task]
      </p>
      <p className="my-0 text-md">
        If you have any questions or need further assistance, please reach out
        to our support team {metaData ? metaData.companySupportEmail : ""}
      </p>
    </Row>
  );
};
